import { useState, useEffect } from "react";
import {
  createLead,
  searchLeads,
  getPaginatedLeads,
} from "../services/leadsService";

const useLeads = () => {
  const [leads, setLeads] = useState<any[]>([]);
  const [isLoading, setIsLoading] = useState<boolean>(false);
  const [error, setError] = useState<string | null>(null);

  // Fetch all leads
  const fetchLeads = async () => {
    setIsLoading(true);
    setError(null);

    try {
      const leadList = await getPaginatedLeads();
      setLeads(leadList);
    } catch (err: any) {
      setError(err.message);
    } finally {
      setIsLoading(false);
    }
  };

  // Create a new lead
  const addLead = async (leadData: any) => {
    setError(null);
    try {
      const newLead = await createLead(leadData);
      setLeads((prevLeads) => [...prevLeads, newLead]);
    } catch (err: any) {
      setError(err.message);
    }
  };

  // Search leads
  const searchLeadsByParams = async ({
    lastName,
    phoneNumber,
  }: {
    lastName?: string;
    phoneNumber?: number;
  }) => {
    setError(null);
    try {
      const searchedLeads = await searchLeads(lastName, phoneNumber);
      setLeads(searchedLeads);
    } catch (err: any) {
      setError(err.message);
    }
  };

  // Fetch paginated leads
  const fetchPaginatedLeads = async (start: number = 1, end: number = 100) => {
    setError(null);
    try {
      const paginatedLeads = await getPaginatedLeads(start, end);
      setLeads(paginatedLeads);
    } catch (err: any) {
      setError(err.message);
    }
  };

  useEffect(() => {
    fetchLeads();
  }, []);

  return {
    leads,
    isLoading,
    error,
    addLead,
    searchLeadsByParams,
    fetchPaginatedLeads,
  };
};

export default useLeads;
